<template>
  <div class="plus-platfrom-section" v-loading="loading">
    <LearnLayouts
      :title="course.name"
      :currentTitle="sectionInfo.name"
      :fold="fold"
      @onClickFold="handleFoldClick"
    >
      <template v-slot:body-main>
        <div class="learn-content-body">
          <div :style="`width:${videoWidth}px; height: 100%`">
            <video
              id="videoPlayer"
              ref="videoPlayer"
              class="video-js vjs-big-play-centered"
              controls
              autoplay
            ></video>
          </div>
        </div>
      </template>
      <template v-slot:body-right>
        <div
          class="page-body-outline"
          :style="`width:${outlineWidth}px`"
          v-show="!fold"
        >
          <div class="outline-content">
            <CourseMenu :contentList="menuRoutes" />
          </div>
        </div>
      </template>
    </LearnLayouts>
  </div>
</template>

<script>
import "video.js/dist/video-js.min.css";
import videojs from "video.js/dist/video.min";
import courseService from "@/global/services/jikerCourse";
import Cookie from "js-cookie";
import LearnLayouts from "@/components/layouts/CourseLayout";
import CourseMenu from "@/components/layouts/CourseLayout/CourseMenu.vue";

export default {
  data() {
    return {
      loading: false,
      menuRoutes: [],
      defaultActive: "",
      course: {},
      sections: [],
      playTime: null,
      endTime: null,
      fold: false,
      videoWidth: window.innerWidth - 240
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    onbeforeunload = () => {
      this.outputTime();
    };
    window.addEventListener("resize", () => {
      this.videoWidth = window.innerWidth - this.outlineWidth;
    });
  },
  computed: {
    sectionInfo() {
      const { sectionId } = this.$route.params;
      const { sections } = this;
      let result = {};
      sections.forEach(data => {
        data.children.forEach(item => {
          if (item.id === Number(sectionId)) {
            result = item;
          }
        });
      });
      return result;
    },
    outlineWidth() {
      return this.fold ? 0 : 240;
    }
  },
  watch: {
    $route() {
      this.setId();
      if (!this.videoInstance) return;
      this.outputTime();
      if (!this.sectionInfo.url) {
        this.$message.error("视频地址无效！");
        return;
      }
      this.videoInstance.src(this.sectionInfo.url);
      courseService.getRecord(this.courseId, this.sectionId).then(res => {
        this.videoInstance.ready(() => {
          this.videoInstance.currentTime(res.last_play_position);
        });
      });
      const {
        courseId,
        chapterId = null,
        sectionId = null
      } = this.$route.params;
      let chapterName = "";
      let sectionName = "";
      this.course.content.forEach(chapter => {
        if (chapter.id == chapterId) {
          chapterName = chapter.name;
          chapter.children &&
            chapter.children.forEach(section => {
              if (section.id == sectionId) {
                sectionName = section.name;
              }
            });
        }
      });
      if (typeof collectEvent == "function") {
        window.collectEvent("chickVideoCourseHours", {
          uuid: Cookie.get("uuid"),
          name: Cookie.get("uname"),
          course: courseId + "-" + this.course.name || "",
          chapter: chapterId + "-" + chapterName || "",
          section: sectionId + "-" + sectionName || ""
        });
      }
    }
  },
  methods: {
    setId() {
      const { courseId, chapterId, sectionId } = this.$route.params;
      this.courseId = courseId;
      this.chapterId = chapterId;
      this.sectionId = sectionId;
    },
    getData: async function() {
      this.setId();
      this.loading = true;
      const { course } = await courseService.item(this.courseId, {
        type: "lesson"
      });
      this.course = course;
      this.sections = course.content;
      if (!this.chapterId) {
        this.$router.replace({
          name: "CourseVideo",
          params: {
            courseId: this.courseId,
            chapterId: this.sections[0].id,
            sectionId: this.sections[0].children[0].id
          }
        });
        this.setId();
      }

      if (!course.is_joined) {
        await courseService.add(this.courseId);
      }

      this.defaultActive = `${this.chapterId}-${this.sectionId}`;
      this.menuRoutes = this.sections.map(data => {
        const params = {
          id: data.id,
          name: data.name
        };
        params.children = data.children.map(item => ({
          id: item.id,
          name: item.name,
          icon: "el-icon-video-play",
          tag: "CourseVideo",
          params: {
            courseId: this.courseId,
            chapterId: data.id,
            sectionId: item.id
          }
        }));
        return params;
      });
      this.getLatestPlay();
    },
    getLatestPlay() {
      courseService
        .getRecord(this.courseId, this.sectionId)
        .then(res => {
          this.last_play_position = res.last_play_position;
          this.initVideo();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initVideo() {
      const videoOption = {
        playbackRates: [0.5, 1, 1.5, 2]
      };
      this.videoInstance = videojs(this.$refs.videoPlayer, videoOption);
      this.videoInstance.src(this.sectionInfo.url);
      this.videoInstance.ready(() => {
        this.videoInstance.currentTime(this.last_play_position);
      });
      this.videoEvent();
    },
    videoEvent() {
      this.videoInstance.on("play", () => {
        this.playTime = new Date();
      });
      this.videoInstance.on("pause", () => {
        this.outputTime();
      });
    },
    outputTime() {
      let course_id = this.courseId;
      let lesson_id = this.sectionId;
      let duration;
      if (this.playTime) {
        this.endTime = new Date();
        duration = this.endTime - this.playTime;
        this.playTime = null;
        this.endTime = null;
      } else {
        duration = 0;
      }
      this.videoInstance.ready(() => {
        let last_play_position = this.videoInstance.currentTime();
        let params = { duration, last_play_position };
        courseService.postRecord(course_id, lesson_id, params);
      });
    },
    handleFoldClick() {
      this.fold = !this.fold;
    }
  },
  components: {
    LearnLayouts,
    CourseMenu
  }
};
</script>

<style type="text/css" lang="less" scoped>
.platform-sider-header {
  height: 60px;
  line-height: 20px;
  font-size: 14px;
  color: #fff;
  padding: 20px 0;
  text-indent: 16px;
  z-index: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: 0 2px 6px 0 rgba(21, 21, 21, 0.45);
  cursor: pointer;
}
.platform-header-middle {
  text-align: center;
}
.platform-content-mainer {
  max-width: 900px;
  padding: 60px 48px;
  margin: 0 auto;
}
.learn-content-body {
  height: calc(100vh - 72px);
  flex: 1;
  position: relative;
  video {
    outline: none;
    // object-fit: cover;
  }
  .video-js {
    position: absolute;
    width: 100%;
    height: calc(100vh - 72px);
  }
}
.page-body {
  &-outline {
    height: 100%;
    overflow-y: auto;
    .outline-content {
      position: sticky;
      top: 20px;
      cursor: pointer;
      text-align: left;
    }
  }
}
</style>
